import React from 'react'

import { DetailsCard } from 'components/shared/DetailsCard/DetailsCard'

export const OutcomeDescription = ({ outcomes }) => (
  <React.Fragment>
    {outcomes.map(key => (
      <DetailsCard.Text key={key}>{key}</DetailsCard.Text>
    ))}
  </React.Fragment>
)
